export const SYSTEM_ALERT_RULE_LABEL = { prometheus: 'openshift-monitoring/k8s' };
